import { HrLeaveEntitlement } from "app/models/hrLeaveEntitlement"
import { Action, Types } from "./hrLeaveEntitlements.actions"

export type HrLeaveEntitlementsState = {
  errors: {}
  loading: boolean
  data: HrLeaveEntitlement[]
}

const initialState: HrLeaveEntitlementsState = {
  errors: {},
  loading: false,
  data: [],
}

export default (state = initialState, action: Action): HrLeaveEntitlementsState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.hrLeaveEntitlements,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }
    case Types.POST:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.DELETE:
      return {
        ...state,
        loading: true,
      }

    case Types.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.DELETE_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
